// extracted by mini-css-extract-plugin
module.exports = {"Component":"StepTwo_Component__3Nvpy"};